// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg width=%27100%27 height=%27100%27 viewBox=%270 0 100 100%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 86c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zm76-26c.552 0 1-.448 1-1s-.448-1-1-1-1 .448-1 1 .448 1 1 1zM8 16c.552 0 1-.448 1-1s-.448-1-1-1-1 .448-1 1 .448 1 1 1z%27 fill=%27%23ffffff%27 fill-opacity=%270.4%27 fill-rule=%27evenodd%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ticket boards overview (/user/Boards). Scoped under .boards-page. */

.boards-page {
  min-width: 0;
}

.boards-page .boards-page__header {
  margin-bottom: var(--ds-space-4);
}

.boards-page .boards-page__title {
  margin: 0 0 var(--ds-space-1);
  font-size: 1.6rem;
  font-weight: 800;
  line-height: 1.2;
}

.boards-page .boards-page__empty {
  margin-top: var(--ds-space-8);
}

/* ── Board card ── */
.boards-page .board-card {
  height: 100%;
  border: 1px solid var(--ds-border-soft);
  border-radius: var(--ds-radius-lg);
  overflow: hidden;
  animation: boards-page-enter 0.4s ease backwards;
}

/* antd makes every direct child of .ant-card-cover display:block, which pushed the icon into
   the corner. */
.boards-page .board-card .ant-card-cover > .board-card__cover {
  display: flex;
}

.boards-page .board-card__cover {
  position: relative;
  height: 110px;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: linear-gradient(135deg, var(--ds-brand-ink) 0%, var(--ds-brand-dark) 100%);
  cursor: pointer;
}

.boards-page .board-card__icon {
  z-index: 1;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: var(--ds-radius-lg);
  background: rgba(255, 255, 255, 0.1);
  color: var(--ds-surface);
  font-size: 32px;
  transition: transform 0.3s ease;
}

.boards-page .board-card__pattern {
  position: absolute;
  inset: 0;
  opacity: 0.1;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  pointer-events: none;
}

.boards-page .board-card__content {
  cursor: pointer;
}

.boards-page .board-card__title-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--ds-space-2);
}

.boards-page .board-card__title {
  margin: 0;
  font-weight: 700;
  min-width: 0;
  overflow-wrap: anywhere;
}

.boards-page .board-card__stats {
  margin-top: var(--ds-space-4);
}

.boards-page .board-card__stat {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2px 0;
}

.boards-page .board-card__progress {
  margin-top: var(--ds-space-2);
}

.boards-page .board-card__small {
  font-size: 12px;
}

.boards-page .board-card .ant-card-actions > li {
  margin: var(--ds-space-1) 0;
}

@keyframes boards-page-enter {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (min-width: 768px) {
  .boards-page .boards-page__title {
    font-size: 2rem;
  }
}

@media (hover: hover) {
  .boards-page .board-card:hover .board-card__icon {
    transform: scale(1.1) rotate(6deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/serviceProvider/components/tickets/boarding.css"],"names":[],"mappings":"AAAA,sEAAsE;;AAEtE;EACE,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,qBAAqB;AACrB;EACE,YAAY;EACZ,uCAAuC;EACvC,kCAAkC;EAClC,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;gBACgB;AAChB;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,sFAAsF;EACtF,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,kCAAkC;EAClC,oCAAoC;EACpC,wBAAwB;EACxB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,yDAAswB;EACtwB,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kCAAkC;EACpC;AACF","sourcesContent":["/* Ticket boards overview (/user/Boards). Scoped under .boards-page. */\n\n.boards-page {\n  min-width: 0;\n}\n\n.boards-page .boards-page__header {\n  margin-bottom: var(--ds-space-4);\n}\n\n.boards-page .boards-page__title {\n  margin: 0 0 var(--ds-space-1);\n  font-size: 1.6rem;\n  font-weight: 800;\n  line-height: 1.2;\n}\n\n.boards-page .boards-page__empty {\n  margin-top: var(--ds-space-8);\n}\n\n/* ── Board card ── */\n.boards-page .board-card {\n  height: 100%;\n  border: 1px solid var(--ds-border-soft);\n  border-radius: var(--ds-radius-lg);\n  overflow: hidden;\n  animation: boards-page-enter 0.4s ease backwards;\n}\n\n/* antd makes every direct child of .ant-card-cover display:block, which pushed the icon into\n   the corner. */\n.boards-page .board-card .ant-card-cover > .board-card__cover {\n  display: flex;\n}\n\n.boards-page .board-card__cover {\n  position: relative;\n  height: 110px;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  background: linear-gradient(135deg, var(--ds-brand-ink) 0%, var(--ds-brand-dark) 100%);\n  cursor: pointer;\n}\n\n.boards-page .board-card__icon {\n  z-index: 1;\n  width: 60px;\n  height: 60px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: var(--ds-radius-lg);\n  background: rgba(255, 255, 255, 0.1);\n  color: var(--ds-surface);\n  font-size: 32px;\n  transition: transform 0.3s ease;\n}\n\n.boards-page .board-card__pattern {\n  position: absolute;\n  inset: 0;\n  opacity: 0.1;\n  background-image: url(\"data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 86c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zm76-26c.552 0 1-.448 1-1s-.448-1-1-1-1 .448-1 1 .448 1 1 1zM8 16c.552 0 1-.448 1-1s-.448-1-1-1-1 .448-1 1 .448 1 1 1z' fill='%23ffffff' fill-opacity='0.4' fill-rule='evenodd'/%3E%3C/svg%3E\");\n  pointer-events: none;\n}\n\n.boards-page .board-card__content {\n  cursor: pointer;\n}\n\n.boards-page .board-card__title-row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: var(--ds-space-2);\n}\n\n.boards-page .board-card__title {\n  margin: 0;\n  font-weight: 700;\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n\n.boards-page .board-card__stats {\n  margin-top: var(--ds-space-4);\n}\n\n.boards-page .board-card__stat {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 2px 0;\n}\n\n.boards-page .board-card__progress {\n  margin-top: var(--ds-space-2);\n}\n\n.boards-page .board-card__small {\n  font-size: 12px;\n}\n\n.boards-page .board-card .ant-card-actions > li {\n  margin: var(--ds-space-1) 0;\n}\n\n@keyframes boards-page-enter {\n  from {\n    opacity: 0;\n    transform: translateY(12px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@media (min-width: 768px) {\n  .boards-page .boards-page__title {\n    font-size: 2rem;\n  }\n}\n\n@media (hover: hover) {\n  .boards-page .board-card:hover .board-card__icon {\n    transform: scale(1.1) rotate(6deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
